import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Alert,
  Row,
  Col,
  message,
  Typography,
} from 'antd';
import { ExclamationCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { requestPasswordReset } from '../../../store/user/actions';
import { types } from '../../../store/user/types';
import { types as formTypes } from '../../../store/forms/types';
import { getLocalString, localNames } from 'utils/localisation.service';
import '../../../styles/pages/_forgotPassword.scss';

const { Paragraph } = Typography;

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [email, setEmail] = useState('');

  const loading = useSelector(state => state.forms.loading);
  const hasError = useSelector(state => state.forms.hasError);
  const initiated = useSelector(state => state.forms.initiated);

  const locales = useSelector(state => state.forms?.localeStrings);

  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [form]);

  useEffect(() => {
    if (initiated && inputRef.current) {
      inputRef.current.focus();
    }
  }, [initiated]);

  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    dispatch({ type: formTypes.SET_FORM_INITIATED });
  }, [dispatch]);

  useEffect(() => {
    if (initiated && inputRef.current) {
      inputRef.current.focus();
    }
  }, [initiated]);

  const handleSubmit = async () => {
    console.log('Email:', email);
    try {
      await dispatch(requestPasswordReset(email));
      message.success('Ο προσωρινός κωδικός έχει σταλεί στο email σας.');
      navigate('/login');
    } catch (error) {
      const errorMessage =
        'Αποτυχία αποστολής email επαναφοράς κωδικού. Παρακαλώ δοκιμάστε ξανά.';
      message.error(errorMessage);
    }
  };

  if (!initiated) return null;

  return (
    <div className={'change-password-wrapper'}>
      <div className={'change-password-page'}>
        <div className={'change-password-header'}>
          <h2 className={'change-password-title'}>Ξεχάσατε τον Κωδικό σας;</h2>
        </div>

        <div className={'change-password-info-container'}>
          <Alert
            id="forgot-password-info-alert"
            type="info"
            showIcon={false} // Disable the default icon
            className={'change-password-info-alert'}
            message={
              <Paragraph className={'change-password-info'}>
                <span className="info-icon">
                  <InfoCircleOutlined />
                </span>
                Εισάγετε το email σας και θα σας στείλουμε οδηγίες για τη
                δημιουργία νέου κωδικού.
              </Paragraph>
            }
          />
        </div>

        <div className={'change-password-form-container'}>
          <Form
            id="forgot-password-form"
            form={form}
            onFinish={handleSubmit}
            onFinishFailed={() => console.log('Form submission failed')}
            layout="vertical"
            className={'change-password-form'}
          >
            <Form.Item
              id="email-field"
              label="Διεύθυνση email :"
              name="email"
              className={'change-password-form-item'}
            >
              <Input
                id="email-input"
                placeholder="Εισάγετε email"
                value={email} // Bind input value to email state
                onChange={e => setEmail(e.target.value)} // Update email state on change
                disabled={loading}
                className={'change-password-input'}
              />
              <Link
                id="back-to-login-link"
                to="/login"
                className={'change-password-back-link'}
              >
                ← Πίσω στην είσοδο
              </Link>
            </Form.Item>

            <div className={'change-password-submit-btn-container'}>
              <Button
                id="forgot-password-submit"
                type="primary"
                htmlType="submit"
                loading={loading}
                className={'change-password-submit-btn'}
              >
                Υποβολή
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
